<template>
  <div :id="id" class="chapter-section panel">
    <p class="panel-heading">{{ $t(`chapter8.title`) }}</p>
    <p class="panel-block">
      {{ $t(`chapter8.text`) }}
      <b-tooltip :label="$t(`general.showInfo`)" position="is-right" type="is-info">
        <b-icon
          type="is-info"
          icon="information-variant"
          class="info-toggle"
          :class="{ 'is-active': showInfo_c8 }"
          @click.native="showInfo_c8 = !showInfo_c8"
        />
      </b-tooltip>
    </p>

    <InfoText :button-label="$t('general.showInfo')" v-if="showInfo_c8">
      {{ $t('chapter8.info') }}
    </InfoText>

    <fieldset class="box">
      <b-field
        :label="$t('chapter8.q0.title')"
        :type="
          store.getFieldError('archivierungLoeschungAnonymisierung', 'loeschfrist')
            ? 'is-danger'
            : ''
        "
        :message="store.getFieldError('archivierungLoeschungAnonymisierung', 'loeschfrist')"
      >
        <div v-for="option in loeschfristOptions" :key="option">
          <b-radio
            :required="true"
            :native-value="option"
            v-model="study.archivierungLoeschungAnonymisierung.loeschfrist"
            @change="onLoeschfristChange"
          >
            {{ $t(`chapter8.q0.${option}`) }}
          </b-radio>
          <b-field
            v-if="
              study.archivierungLoeschungAnonymisierung.loeschfrist === 'sonstige' &&
              option === 'sonstige'
            "
            :type="
              store.getFieldError('archivierungLoeschungAnonymisierung', 'loeschfristSonstige')
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError('archivierungLoeschungAnonymisierung', 'loeschfristSonstige')
            "
          >
            <b-input
              :required="study.archivierungLoeschungAnonymisierung.loeschfrist === 'sonstige'"
              :placeholder="$t('chapter8.q0.sonstigeText')"
              v-model="study.archivierungLoeschungAnonymisierung.loeschfristSonstige"
              @blur="save"
            />
          </b-field>
        </div>
      </b-field>
    </fieldset>

    <fieldset class="box">
      <b-field
        :label="$t('chapter8.q1.title')"
        :type="
          store.getFieldError('archivierungLoeschungAnonymisierung', 'aalPersonenbezogeneDaten')
            ? 'is-danger'
            : ''
        "
        :message="
          store.getFieldError('archivierungLoeschungAnonymisierung', 'aalPersonenbezogeneDaten')
        "
      >
        <div v-for="option in aalPersonenbezogeneDatenOptions" :key="option">
          <b-radio
            :required="true"
            :native-value="option"
            v-model="study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDaten"
            @change="onArchivierungChange"
          >
            {{ $t(`chapter8.q1.${option}`) }}
          </b-radio>
          <b-field
            v-if="
              study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDaten === 'diz' &&
              option === 'diz'
            "
          >
            <b-input
              :placeholder="$t(`chapter8.q1.dizPlaceholder`)"
              v-model="study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDatenDiz"
              @blur="save"
            />
          </b-field>
          <b-field
            v-if="
              study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDaten === 'sonstige' &&
              option === 'sonstige'
            "
          >
            <b-input
              v-model="study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDatenSonstige"
              :placeholder="$t(`chapter8.q1.sonstigeText`)"
              @blur="save"
            />
          </b-field>
        </div>
      </b-field>
    </fieldset>
  </div>
</template>

<script setup lang="ts">
import { useStudyStore } from '@/stores/studyStore'
import { useInfoToggle } from '@/composables/useVisibilityToggles'
import InfoText from '@/components/InfoText.vue'
import { BField, BIcon, BInput, BRadio, BTooltip } from 'buefy'

defineProps<{ id: string; modelValue?: object }>()

const store = useStudyStore()
const study = store.study
const title = 'Löschfrist, Archivierung, Anonymisierung'

const aalPersonenbezogeneDatenOptions = ['diz', 'abteilungseigeneArchive', 'weilhammer', 'sonstige']
const loeschfristOptions = ['10j', '15j', '25j', 'sonstige']

const save = () => {
  store.updateChapter(
    'archivierungLoeschungAnonymisierung',
    study.archivierungLoeschungAnonymisierung,
  )
}

const showInfo_c8 = useInfoToggle()

function onLoeschfristChange() {
  if (study.archivierungLoeschungAnonymisierung.loeschfrist !== 'sonstige') {
    study.archivierungLoeschungAnonymisierung.loeschfristSonstige = undefined
  }
  save()
}

function onArchivierungChange() {
  if (study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDaten !== 'diz') {
    study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDatenDiz = undefined
  }
  if (study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDaten !== 'sonstige') {
    study.archivierungLoeschungAnonymisierung.aalPersonenbezogeneDatenSonstige = undefined
  }
  save()
}
</script>

<style scoped></style>
